import { PaginatedListResult, usePaginatedList } from "@hooks/usePaginatedList";
import { ServicesURL } from "@utils/utilsApi";
import { WaitingUserItem } from "../types";

interface UseWaitingUsersListArgs {
  corporateId: string | number;
  objectId: number;
  editionId?: number;
  page: number;
  pageSize: number;
  search?: string;
}

export const useWaitingUsersList = ({
  corporateId,
  objectId,
  editionId,
  page,
  pageSize,
  search,
}: UseWaitingUsersListArgs): PaginatedListResult<WaitingUserItem> => {
  const editionParam = editionId ? `&editionId=${editionId}` : "";
  const url = corporateId
    ? `${ServicesURL.getUsersWaiting}?corporateId=${corporateId}&objectId=${objectId}${editionParam}`
    : null;

  return usePaginatedList<WaitingUserItem>(
    url,
    {
      page,
      pageSize,
      search,
    },
    {
      responseKey: "output",
      totalElementsKey: "total_elements",
      totalPagesKey: "total_pages",
    },
  );
};
